export const stripeConfig = {
    //publishableKey: 'pk_test_rnfl7WRJHAgakpRWhSNxljIT', // Test (Ambidect)
    publishableKey: 'pk_live_51MrgtzLvsHSdIL0eQmSuJK25605eSBibsuqNCC9bAkRL0fYEj9uXvnApst09aeP10KdkJjk5a7fP163SlR3RpQ7C00NxeDu00s', // Live (Greenbridge)
};